// extracted by mini-css-extract-plugin
export var addressAndMapWrapper = "ContactView-module--addressAndMapWrapper--7d56d";
export var addressesText = "ContactView-module--addressesText--a90dc typography-module--paragraphSansMedium--1b5f1";
export var addressesTextWrapper = "ContactView-module--addressesTextWrapper--cb5cb";
export var desktopImageWrapper = "ContactView-module--desktopImageWrapper--9ee2c";
export var googleMaps = "ContactView-module--googleMaps--c8733";
export var mainBody = "ContactView-module--mainBody--38e42";
export var mobileImage = "ContactView-module--mobileImage--176b5";
export var mobileSocial = "ContactView-module--mobileSocial--21f58";
export var mobileText = "ContactView-module--mobileText--f0991";
export var socialMedia = "ContactView-module--socialMedia--cb994";
export var text = "ContactView-module--text--a1c78 typography-module--paragraphSans--0fb30";
export var title = "ContactView-module--title--5eeb3 typography-module--responsiveTitle4--45808";
export var wrapper = "ContactView-module--wrapper--85191";